export default __webpack_public_path__ + "static/media/Merchant-portal-refund.bc9ca9be.png";